






































import { round } from 'lodash-es'

export default {
  props: {
    size: {
      type: [Number, String],
      default: 100,
    },
    progress: {
      type: [Number, String],
      required: true,
    },
    hideText: {
      type: Boolean,
      default: false,
    },
    hideBg: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#aaa',
    },
    strokeWidth: {
      type: String,
      default: '8',
    },
  },
  computed: {
    limitedProgress() {
      return Math.min(Math.max(0, round(this.progress)), 100)
    },
    r() {
      return (this.numSize - parseInt(this.strokeWidth, 10)) * 0.5
    },
    circumference() {
      return Math.ceil(2 * this.r * Math.PI)
    },
    dashoffset() {
      return this.circumference - this.circumference * (this.limitedProgress / 100)
    },
    numSize() {
      return parseInt(this.size, 10)
    },
  },
}
